import { render } from "./Demo.vue?vue&type=template&id=a6360e7c"
const script = {}

import "./Demo.vue?vue&type=style&index=0&id=a6360e7c&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__